namespace GeniuzPOS.AdvPromo {
    export class Adv05HdColumns {
        static columnsKey = 'AdvPromo.Adv05Hd';
    }
}
